import React, { useEffect } from "react";
import RentForm from "./RentForm";
import { Link, useNavigate } from "react-router-dom";
import { MdDoubleArrow } from "react-icons/md";
import MultiStepForm from "./MultiStepForm";
import { useDispatch, useSelector } from "react-redux";
import { getGpsPayment, getUserDetail } from "../../redux/Slice/authSlice";

const Index = () => {
  const navigate = useNavigate();
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const dispatch = useDispatch();
  const userDetailsData = useSelector((state) => state?.auth?.userDetail);

  useEffect(() => {
    if (!loginDetail) {
      navigate("/login");
    }
    if (userDetailsData?.data?._id) {
      dispatch(getUserDetail(userDetailsData?.data?._id));
    }

    dispatch(getGpsPayment());
  }, []);

  return (
    <div className="container px-0 pb-6">
      <div className="p-3">
        <h2 className="font accentColor mt-2 mb-4">
          <MdDoubleArrow />
          Rent Your Car
        </h2>
        <p className="secondaryColor fs18">
          List Your Car Now and start earning with theRides! Join our community
          of car owners making the most of their vehicles.
        </p>
        <p className="text-danger">
          PS : Read Terms and conditions before renting your car
        </p>
      </div>
      <MultiStepForm />
      {/* <RentForm /> */}
    </div>
  );
};

export default Index;
